import React from 'react';
import { getCSSVariableValue } from '../utils/getCSSVariableValue.js';

const backgroundColor = getCSSVariableValue('--bc-buttons');
const lineColor = getCSSVariableValue('--fc-buttons');

function MobileMenuClose(props) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50" fill="none" {...props}>
            <circle cx="25" cy="25" r="25" fill={backgroundColor}/>
            <line x1="32.9101" y1="32.617" x2="16.6467" y2="16.3535" stroke={lineColor}/>
            <line x1="33.6172" y1="16.617" x2="17.3538" y2="32.8804" stroke={lineColor}/>
        </svg>
    );
}

export default MobileMenuClose;